import { render, staticRenderFns } from "./TextareaGroup.vue?vue&type=template&id=0921bc61"
import script from "./TextareaGroup.vue?vue&type=script&lang=js"
export * from "./TextareaGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports